import {
  BrainIcon,
  CompareIcon,
  GrowthIcon,
  MagnifierIcon,
  SaveIcon,
} from '@growdash/growintel/assets/icons';

import { Brand } from '../generated';
import { GROWINTEL_PATHS } from './GrowintelPaths';

export type IPageFilters = {
  search: {
    brand: {
      name: string;
      city?: string;
      area?: string;
      cuisine?: string;
    };
    branch: {
      name: string;
      city?: string;
      area?: string;
      cuisine?: string;
    };
    item: {
      name: string;
      city?: string;
      area?: string;
      cuisine?: string;
    };
  };
  trends: {
    brand: Brand | undefined | null;
    cuisine: string | undefined | null;
    city: string | undefined | null;
    areas: string[] | undefined | null;
  };
  compare: {
    firstBrand: Brand | undefined | null;
    secondBrand: Brand | undefined | null;
  };
  watchlist: {
    brandId: string | undefined | null;
  };
  ai: {
    menuReviewBrand: Brand | undefined | null;
    menuGenerateBrand: Brand | undefined | null;
  };
};

export type TabValue = keyof IPageFilters;

type ITab<V extends TabValue = TabValue> = {
  value: V;
  title: string;
  path: string;
  icon: any;
  initialFilters: IPageFilters[V];
  selectedSubTab?: string;
};

type TabsMapType = {
  [K in TabValue]: ITab<K>;
};

export const TabsMap: TabsMapType = {
  trends: {
    title: 'Trends',
    value: 'trends',
    path: GROWINTEL_PATHS.TRENDS,
    icon: GrowthIcon,
    initialFilters: {
      brand: null,
      cuisine: '',
      city: '',
      areas: [],
    },
  },
  compare: {
    title: 'Compare',
    value: 'compare',
    path: GROWINTEL_PATHS.COMPARE,
    icon: CompareIcon,
    initialFilters: {
      firstBrand: null,
      secondBrand: null,
    },
  },
  watchlist: {
    title: 'Watchlist',
    value: 'watchlist',
    path: GROWINTEL_PATHS.WATCHLIST,
    icon: SaveIcon,
    initialFilters: {
      brandId: null,
    },
  },
  search: {
    title: 'Search',
    value: 'search',
    path: GROWINTEL_PATHS.SEARCH,
    icon: MagnifierIcon,
    initialFilters: {
      brand: {
        name: '',
        city: '',
        area: '',
        cuisine: '',
      },
      branch: {
        name: '',
        city: '',
        area: '',
        cuisine: '',
      },
      item: {
        name: '',
        city: '',
        area: '',
        cuisine: '',
      },
    },
  },
  ai: {
    title: 'Menu AI',
    value: 'ai',
    path: GROWINTEL_PATHS.AI,
    icon: BrainIcon,
    initialFilters: {
      menuReviewBrand: null,
      menuGenerateBrand: null,
    },
    selectedSubTab: 'menu-generate',
  },
};

export const Tabs = Object.values(TabsMap);
